import React, { useEffect, useState } from 'react';
import { PropTypes } from 'prop-types';
import { setPrimaryImage } from '../../../utils/api/site';
import SiteImagesCarousel from './SiteImagesCarousel';

const SiteImage = ({
  images,
  heightStyle = '',
  siteId,
  organizationId,
  isModal,
  modalImageId = null,
  setModalImageId = () => {},
  onCurrentImageChange = null,
}) => {
  const [primaryImgId, setPrimaryImageId] = useState(null);

  useEffect(() => {
    // primaryImgId is used to help fix the following edge case:
    // 1. A different image is set as the primary imag inside onSetPrimaryImage()
    // 2. The images are not updated because backend doesn't return the updated images
    // 3. The primary image is deleted and causes images to no longer display
    if (images && images.length > 0) {
      const currentPrimaryImg = images.find(img => img?.primary);
      if (currentPrimaryImg) {
        setPrimaryImageId(currentPrimaryImg.id);
      } else {
        // default to first image to avoid displaying nothing
        const firstImgId = images[0]?.id;
        setPrimaryImageId(firstImgId);
        // API call to help prevent site cards from displaying nothing
        setPrimaryImage({ organization_id: organizationId }, siteId, firstImgId);
      }
    }
  }, [images, siteId, organizationId]);

  return (
    <div>
      <SiteImagesCarousel
        images={images}
        primaryImgId={primaryImgId}
        heightStyle={heightStyle}
        isModal={isModal}
        modalImageId={modalImageId}
        setModalImageId={setModalImageId}
        onCurrentImageChange={onCurrentImageChange}
      />
    </div>
  );
};

SiteImage.propTypes = {
  siteId: PropTypes.number.isRequired,
  heightStyle: PropTypes.string,
  organizationId: PropTypes.number.isRequired,
  images: PropTypes.arrayOf(PropTypes.object).isRequired,
  isModal: PropTypes.bool.isRequired,
  modalImageId: PropTypes.number,
  setModalImageId: PropTypes.func,
  onCurrentImageChange: PropTypes.func,
};

export default SiteImage;
